import { render, staticRenderFns } from "./LogOut.vue?vue&type=template&id=5b509842&scoped=true"
import script from "./LogOut.vue?vue&type=script&lang=js"
export * from "./LogOut.vue?vue&type=script&lang=js"
import style0 from "./LogOut.vue?vue&type=style&index=0&id=5b509842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b509842",
  null
  
)

export default component.exports